import React from "react";
import { Link } from "react-router-dom";

// Square, editorial button. variant: solid | outline | ghost
export const TRButton = React.forwardRef(
    (
        {
            children,
            variant = "solid",
            as = "button",
            to,
            className = "",
            full = false,
            ...props
        },
        ref,
    ) => {
        const base =
            "inline-flex items-center justify-center gap-2 uppercase tracking-[0.18em] text-[0.72rem] font-medium px-8 py-4 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] disabled:opacity-40 disabled:cursor-not-allowed";
        const variants = {
            solid:
                "bg-ink text-paper hover:bg-ink/85 border border-ink",
            outline:
                "bg-transparent text-ink border border-ink hover:bg-ink hover:text-paper",
            ghost:
                "bg-transparent text-ink border border-line hover:border-ink",
        };
        const cls = `${base} ${variants[variant]} ${full ? "w-full" : ""} ${className}`;

        if (as === "link" && to) {
            return (
                <Link to={to} className={cls} ref={ref} {...props}>
                    {children}
                </Link>
            );
        }
        return (
            <button className={cls} ref={ref} {...props}>
                {children}
            </button>
        );
    },
);
TRButton.displayName = "TRButton";
